import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './IconDropzone.scss'

import Dropzone from 'react-dropzone'

const IconDropzone = ({ error, displayFile, handleFileDrop, disabled }) => {
	const disabledClass = disabled ? styles.disabled : ''
	const errorClass = error ? styles.error : ''
	return !disabled
		? <Dropzone
				onDrop={handleFileDrop}
				styleName="dropzone"
				className={[disabledClass, errorClass].join(' ')}
				accept="image/jpeg, image/png"
				multiple={false}
			>
				{displayFile
					? <img
							styleName="icon"
							src={displayFile}
							role="presentation"
						/>
					: <span styleName="dropzone-msg">
							<i className="material-icons">file_upload</i>
							<br />Drop your<br /> image here or click to browse
						</span>}
			</Dropzone>
		: <div styleName="dropzone" className={disabledClass}>
				{displayFile
					? <img
							styleName="icon"
							src={displayFile}
							role="presentation"
						/>
					: <span styleName="dropzone-msg">
							You didn't<br />set up the<br />icon yet
						</span>}
			</div>
}

export default CSSModules(IconDropzone, styles)



// WEBPACK FOOTER //
// ./src/components/Dropzone/IconDropzone.js